import tailwindConfig from '../../../tailwind.config';

export const TAILWIND_COLORS = tailwindConfig.theme.colors;
